export interface FileMetadata {
  name: string;
  size: number;
  type: string;
  lastModified: number;
}

export interface TravelExpense {
  id: string;
  date: string;
  description: string;
  category: ExpenseCategory;
  amount: number;
  currency: string;
  location: string;
  duration?: string;
  receipt?: File;
  receiptMetadata?: FileMetadata;
  receiptFileId?: string; // Reference to file stored in IndexedDB
}

export enum ExpenseCategory {
  BELEGE = "Belege",
  SPESENABRECHNUNG = "Spesenabrechnung",
}

export interface TravelExpenseReport {
  employeeName: string;
  employeeStreet: string;
  employeeCity: string;
  employeeZipCode: string;
  quarterPeriod: string;
  expenses: TravelExpense[];
  totalAmount: number;
}

export interface ExpenseFormData {
  date: string;
  description: string;
  category: ExpenseCategory;
  amount: string;
  location: string;
  duration?: string;
  receipt?: File;
  receiptMetadata?: FileMetadata;
}
